import React from "react";

import {
  Flex,
  FlexProps,
  Heading,
  Link,
  Truncate,
} from "@catchoftheday/cg-components";

type ProductCardTitleProps = Pick<FlexProps, "onClick"> & {
  productId: string;
  title: string;
  url: string;
};

export const ProductCardTitle = ({
  productId,
  title,
  url,
  onClick,
}: ProductCardTitleProps) => (
  <Flex
    position="relative"
    flexShrink={0}
    justifyContent="center"
    px="6px"
    color="color.text"
    fontWeight="normal"
    onClick={onClick}
  >
    <Truncate lines={2}>
      <Heading.h2 m={0} color="currentColor" fontSize="base">
        <Link
          color="currentColor"
          hoverColor="currentColor"
          href={url}
          title={`View ${title}`}
          data-product-id={productId}
        >
          {title}
        </Link>
      </Heading.h2>
    </Truncate>
  </Flex>
);
